import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

const opts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#005591',
        secondary: '#00A0E1',
        porcelain: '#F7F9F9',

      }
    }
  }
}

export default new Vuetify(opts)
